import axios from "axios";

import Config from "src/config";

const v1_actionBuscarMensagensArquivos = (querys, data) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/buscar-arquivos${querys}`,
        data
    });
};

export default v1_actionBuscarMensagensArquivos;
